import React from 'react'
import styled from 'styled-components';
// import { Modal } from 'ui/Modal'
import { Table as BSTable, Modal } from 'react-bootstrap';
import moment from 'moment';
import NumberFormat from 'react-number-format';






const TableWrapper = styled.div`
  position: relative;
  background: #3a3b48 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 6px #0000000a;
  padding: 15px 25px;
  border-radius: 5px;
  min-height: 470px;
  width:1000px;
`;

const StyledTable = styled(BSTable)`
  td {
    height: 42px;
    text-align: center;
    font-family: 'Montserrat Alternates';
    font-size: 11px;
    line-height: 25px;
    border-bottom: 1px solid gray;
    color: #b5b5b5;
    @media (min-width: 768px) and (max-width: 1024px) {
      font-size: 9px;
    }
  }
  th {
    height: 42px;
    text-align: center;
    font-family: 'Montserrat Alternates-semiBold';
    font-size: 11px;
    line-height: 25px;
    color: #ffffff;
    position: sticky;
    top: 0;
    background:  #0081c5 ;
    z-index: 1;
    @media (min-width: 768px) and (max-width: 1024px) {
      font-size: 9px;
    }
  }
  td:first-child, th:first-child {
    text-align: left;
  }
`;

const TableHead = styled.thead`
  tr {
    background:  #0081c5 ;
    border-bottom: underline;
    @media (min-width: 768px) and (max-width: 1024px) {
      th {
        background: #0081c5;
      }
    }
    &:hover {
      background: transparent linear-gradient(90deg, #0081c5 0%, #31c0de 100%) 0% 0% no-repeat padding-box;
      color: #ffffff;
    }
  }
`;

const StyledRow = styled.tr`
  color: #b5b5b5;
  cursor: pointer;
  &:hover {
    background-color: #636471;
    color: #ffffff;
  }
`;

const ScrollableTbody = styled.div`
  max-height: 400px; /* Adjust height as needed */
  overflow-y: auto;

  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background: #000;
  }
  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
const RefundTransactionModal = ({show,hide,data = []}) => {

    const ArrayData = Array.isArray(data) ? data : [data];
    const columns = React.useMemo(() => [
        { Header: "Transaction ID", accessor: "transactionId", id: "transactionId" },
        { Header: 'Date', accessor: (row) => {
         
            const formattedDate = row?.TransactionTimeStamp 
                ? moment(row.TransactionTimeStamp).format('MM/DD/YYYY') 
                : '-';
            return formattedDate;
        }, id: 'TransactionTimeStamp' },
        { Header: 'Amount', accessor: (row)=>{
            return(
                <NumberFormat
                    thousandSeparator={true}
                    prefix={'$'}
                    decimalScale={2}
                    value={row.invoiceAmount}
                    displayType={'text'}
                />
            )
        }, id: 'invoiceAmount' },
      
        { Header: 'Status', accessor: (row) => {
                const status = row?.transactionDetails[0]?.transactionStatus;
                return status
        }, id: 'status' },
    ], [data]);
    
  return (
   <Modal 
  show={show}
  onHide={() => hide(false)}
  centered
  className="cashforcast-accounts"
>
  <TableWrapper>
    <StyledTable responsive borderless>
      <TableHead>
        <StyledRow>
          {columns?.map((column) => (
            <th key={column.id}>{column.Header}</th>
          ))}
        </StyledRow>
      </TableHead>
    </StyledTable>

    <ScrollableTbody>
      <StyledTable responsive borderless>
        <tbody>
          {ArrayData.map((row, index) => (
            <StyledRow key={index}>
              {columns.map((column) => (
                <td key={column.id}>
                  {typeof column.accessor === 'function'
                    ? column.accessor(row)
                    : row[column.accessor] !== undefined
                    ? row[column.accessor]
                    : '-'}
                </td>
              ))}
            </StyledRow>
          ))}
        </tbody>
      </StyledTable>
    </ScrollableTbody>
  </TableWrapper>
</Modal>

  )
}

export default RefundTransactionModal